import { render, staticRenderFns } from "./TimeLimitSelector.vue?vue&type=template&id=5f3a86d3"
import script from "./TimeLimitSelector.vue?vue&type=script&lang=js"
export * from "./TimeLimitSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports